module.exports = __webpack_public_path__ + "static/media/icon_205.153fecc6.svg";